// import HomeBanner from "../components/layout/HomeBanner";
import Fragrances from "../components/project/Fragrances";
function Home() {
  return (
    <main>
      <Fragrances></Fragrances>
    </main>
  );
}

export default Home;
